interface ToolTipQuestionMarkProps {
  toolTipID: string
  ariaLabel?: string
}

export function ToolTipQuestionMark({
  toolTipID = '',
  ariaLabel,
}: ToolTipQuestionMarkProps) {
  return (
    <div>
      <i
        className="icon-help-outline fs16 gray-light-color ibm"
        data-tooltip-content=""
        data-tooltip-id={toolTipID}
        {...(ariaLabel !== undefined && {
          'aria-label': ariaLabel,
          role: 'img',
        })}
      />
    </div>
  )
}
